import { lazy } from "react";
import Loadable from "app/components/Loadable";
//import ExcelDisplay from "../exceldisplay";

const JobTable = Loadable(lazy(() => import("./tables/JobTable")));

//const DocTable = Loadable(lazy(() => import("./tables/documentTable")));
const AddTask = Loadable(lazy(() => import("./tables/createtask")));

const AppDialog = Loadable(lazy(() => import("./Jobs/editjob")));
const EditTask = Loadable(lazy(() => import("./Jobs/edittask")));

const UploadJobs = Loadable(lazy(() => import("./Jobs/uploadjobs")));
const UserDetails = Loadable(lazy(() => import("./UserDetails/UserDetails")));
//const Roles = Loadable(lazy(() => import("./UserDetails/rolemangements")));
const Dashboard1 = Loadable(lazy(() => import("../dashboard/dashboard")));

const RequestTable = Loadable(lazy(() => import("./tables/requesttable")));

const Productivity = Loadable(lazy(() => import("../reports/Productivity")));
const GenTimesheet = Loadable(
  lazy(() => import("../reports/GeneralTimesheet")),
);
const GenApproveTimeSheet = Loadable(
  lazy(() => import("../reports/ApproveTimesheet")),
);
const UsersWeeklyTimeSheet = Loadable(
  lazy(() => import("../reports/usersweeklyreport")),
);
const DailyProductivity = Loadable(
  lazy(() => import("../reports/DailyProductivity")),
);
const QAQCReport = Loadable(lazy(() => import("../reports/QAQCReport")));
const PlanVsActualReport = Loadable(
  lazy(() => import("../reports/PlanVsActualReport")),
);
const WSActivityReport = Loadable(
  lazy(() => import("../reports/WSActivityReport")),
);
const BAUReport = Loadable(lazy(() => import("../reports/BAUReport")));
const TimesheetReport = Loadable(
  lazy(() => import("../reports/TimesheetReport")),
);
const JobStatusReport = Loadable(
  lazy(() => import("../reports/JobStatusReport")),
);
const JobLimitStatusReport = Loadable(
  lazy(() => import("../reports/JobLimitStatusReport")),
);
const AchievementReport = Loadable(
  lazy(() => import("../reports/achievement_report")),
);
const DelHistoryReport = Loadable(
  lazy(() => import("../reports/DelHistoryReport")),
);
const DailyUsersStatusReport = Loadable(
  lazy(() => import("../reports/DailyUsersStatusReport")),
);
const OverallUsersStatusReport = Loadable(
  lazy(() => import("../reports/OverallUsersStatusReport")),
);
const ParHistoryReport = Loadable(
  lazy(() => import("../reports/ParHistoryReport")),
);
const SLAReport = Loadable(lazy(() => import("../reports/SLAReport")));
const DailyStatusReport = Loadable(
  lazy(() => import("../reports/DailyStatusReport")),
);
const DeliveryReport = Loadable(
  lazy(() => import("../reports/DeliveryReport")),
);
const MonthwiseDeliveryReport = Loadable(
  lazy(() => import("../reports/MonthwiseDeliveryReport")),
);
const AllJobs = Loadable(lazy(() => import("../reports/alljobs")));
const HoldJobsReport = Loadable(
  lazy(() => import("../reports/HoldJobsReport")),
);
const BAUInputsTrend = Loadable(
  lazy(() => import("../reports/BAUInputsTrend")),
);
const ViewEditWorkorders = Loadable(
  lazy(() => import("../Workorders/ViewEditWorkorders")),
);
const Observations = Loadable(lazy(() => import("../Workorders/Observations")));
const UploadWorkorders = Loadable(
  lazy(() => import("../Workorders/UploadWorkorders")),
);

const QueryByStatus = Loadable(lazy(() => import("../QMS/QueryByStatus")));
const AdvancedSearch = Loadable(lazy(() => import("../QMS/Adavancedsearch")));

const ModulesScreens = Loadable(
  lazy(() => import("../ConfigurationReports/rolemangements")),
);
const UserManagement = Loadable(
  lazy(() => import("../ConfigurationReports/UserManagement")),
);
const AddParams = Loadable(
  lazy(() => import("../ConfigurationReports/AddParams")),
);
const AddOutages = Loadable(
  lazy(() => import("../ConfigurationReports/AddOutages")),
);

const materialRoutes = [
  { path: "/viewjobs", element: <JobTable /> },

  // { path: "/doctable", element: <DocTable /> },
  { path: "/createtask", element: <AddTask /> },

  { path: "/material/editjob", element: <AppDialog /> },
  { path: "/material/edittask", element: <EditTask /> },
  { path: "/uploadjobs", element: <UploadJobs /> },
  //{ path: "/material/exceldispaly", element: <ExcelDisplay /> },
  { path: "/userdetails", element: <UserDetails /> },
  // { path: "/roles", element: <Roles /> },
  { path: "/dashboard", element: <Dashboard1 /> },
  { path: "/requests", element: <RequestTable /> },
  { path: "/productivity", element: <Productivity /> },

  { path: "/generaltimesheet", element: <GenTimesheet /> },
  { path: "/approvetimesheet", element: <GenApproveTimeSheet /> },
  { path: "/usersweeklytimesheet", element: <UsersWeeklyTimeSheet /> },

  { path: "/dailyproductivity", element: <DailyProductivity /> },
  { path: "/qaqcreport", element: <QAQCReport /> },
  { path: "/planavsctual", element: <PlanVsActualReport /> },
  { path: "/wsactivityresources", element: <WSActivityReport /> },
  { path: "/bau", element: <BAUReport /> },
  { path: "/timesheet", element: <TimesheetReport /> },
  { path: "/jobstatus", element: <JobStatusReport /> },
  { path: "/delhistory", element: <DelHistoryReport /> },
  { path: "/dailyuserreport", element: <DailyUsersStatusReport /> },
  { path: "/overalluserreport", element: <OverallUsersStatusReport /> },
  { path: "/parhistory", element: <ParHistoryReport /> },
  { path: "/slareport", element: <SLAReport /> },
  { path: "/dailystatusreport", element: <DailyStatusReport /> },
  { path: "/deliveryreport", element: <DeliveryReport /> },
  { path: "/monthwisereport", element: <MonthwiseDeliveryReport /> },
  { path: "/alljobs", element: <AllJobs /> },
  { path: "/holdjobs", element: <HoldJobsReport /> },
  { path: "/bauinputs", element: <BAUInputsTrend /> },
  { path: "/joblimitstatus", element: <JobLimitStatusReport /> },
  { path: "/achievementreport", element: <AchievementReport /> },

  { path: "/vieweditworkorders", element: <ViewEditWorkorders /> },
  { path: "/observations", element: <Observations /> },
  { path: "/UploadWorkorders", element: <UploadWorkorders /> },

  { path: "/querybystatus", element: <QueryByStatus /> },
  { path: "/advancedsearch", element: <AdvancedSearch /> },

  { path: "/modulesscreens", element: <ModulesScreens /> },
  { path: "/usermanagement", element: <UserManagement /> },
  { path: "/addparams", element: <AddParams /> },
  { path: "/addoutages", element: <AddOutages /> },
];

export default materialRoutes;
